import { palette2, RcRating, RcTypography, styled } from '@ringcentral/juno';

export const RatingContainer = styled.div`
  display: flex;
  margin-top: auto;
`;

export const StyledRating = styled(RcRating)`
  height: 20px;

  .MuiRating-decimal {
    margin-right: 4px;
  }

  .RcRating-label {
    padding: 0;
  }

  &&& {
    .RcRating-icon {
      padding: 0;
    }

    .RcRating-iconEmpty {
      color: ${palette2('warning', 'f01')};
    }

    .icon {
      font-size: 20px;
    }
  }
`;

export const RatingCount = styled(RcTypography)`
  margin-left: 4px;
  height: 20px;
  padding-top: 3px;
`;
